export default Object.freeze({
  MOBILE: 'mobile',
  DESKTOP: 'desktop',
  EXTENSION: 'extension',
  OTHER: 'other',
})
